import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-admin-area',
  templateUrl: './admin-area.component.html',
  styleUrls: ['./admin-area.component.css']
})
export class AdminAreaComponent implements OnInit {

  selectedArea = 'homepage';

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if(params.get('section'))
        this.selectedArea = params.get('section');
    });
  }
  changeSection(section) {
    this.router.navigate(['/adminarea/' + section]);
  }
}
